import { Link } from "react-router-dom"

import { BrandMark } from "./brand-mark"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "./ui/sidebar"
import logoIcon from "@/client/assets/brand/ff-icon.png"

export function SidebarBrand() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          size="lg"
          asChild
          className="h-14 hover:bg-transparent active:bg-transparent"
        >
          <Link to="/admin" aria-label="FeelyFeely Admin">
            {/* Collapsed icon mode */}
            <span className="hidden size-8 shrink-0 items-center justify-center rounded-lg group-data-[collapsible=icon]:flex">
              <img src={logoIcon} alt="" className="size-5 object-contain" />
            </span>

            {/* Expanded admin header banner */}
            <span className="rounded-lg px-2.5 py-2 group-data-[collapsible=icon]:hidden">
              <BrandMark />
            </span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
